/* ========================================================================== *\
    IMPORTS
\* ========================================================================== */

import bind from 'lodash/bind';
import forEach from 'lodash/forEach';
import isNil from 'lodash/isNil';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
    PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'photo-zoom',
    baseCssClass = `js-${moduleName}`,

    dataAttributes = {
        image: 'data-image'
    },
    propertyNames = {
        baseElement: Symbol('baseElement'),
        triggers: Symbol('triggers'),
        image: Symbol('image'),
        imageTarget: Symbol('imageTarget'),
        dialog: Symbol('dialog'),
        close: Symbol('close')
    },
    selectors = {
        base: `.${baseCssClass}`,
        triggers: `.${baseCssClass}-trigger`,
        image: `.${baseCssClass}-image`,
        imageTarget: `.${baseCssClass}-image-target`,
        dialog: `.${baseCssClass}-dialog`,
        close: `.${baseCssClass}-close`
    },
    states = {
        isOpen: 'is-open'
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
    EVENT HANDLING
\* ========================================================================== */

function bindEvents() {
    const
        triggers = this[propertyNames.triggers],
        dialog = this[propertyNames.dialog],
        close = this[propertyNames.close];
    if (
        triggers === null ||
        dialog === null ||
        close === null)
    {
        return;
    }

    forEach(triggers, trigger => {
        trigger.addEventListener('click', bind(onClickTrigger, this));
    });

    
    close.addEventListener('click', bind(onClickClose, this));
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
    PRIVATE METHODS
\* ========================================================================== */

function onClickClose() {
    this[propertyNames.dialog].classList.remove(states.isOpen);
}

function onClickTrigger(image) {
    const 
        imageSrc = image.target.getAttribute(dataAttributes.image),
        imageTarget = this[propertyNames.imageTarget];

    if (imageSrc === null) {
        return;
    }

    if (this[propertyNames.dialog].classList.contains(states.isOpen)) {
        this[propertyNames.dialog].classList.remove(states.isOpen);
    } else {
        this[propertyNames.dialog].classList.add(states.isOpen);
        console.log(imageSrc)
        imageTarget.setAttribute("src", imageSrc);

    }
}
/* == PRIVATE METHODS ======================================================= */


/* ========================================================================== *\
    PUBLIC API
\* ========================================================================== */

class photoZoom {

    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (isNil(baseElement)) {
            throw 'Unable to create instance of photoZoom, no base element has been provided';
        }

        this[propertyNames.baseElement] = baseElement;
        this[propertyNames.triggers] = baseElement.querySelectorAll(selectors.triggers);
        this[propertyNames.dialog] = baseElement.querySelector(selectors.dialog);
        this[propertyNames.image] = baseElement.querySelector(selectors.image);
        this[propertyNames.imageTarget] = baseElement.querySelector(selectors.imageTarget);
        this[propertyNames.close] = baseElement.querySelector(selectors.close);

        bindEvents.call(this);
    }

    /* == CONSTRUCTOR ======================================================= */
}

/* == PUBLIC API ============================================================ */



/* ========================================================================== *\
    INITIALIZATION
\* ========================================================================== */

function init(baseElements = document.querySelectorAll(selectors.base)) {
    if (
        baseElements === null ||
        baseElements.length === 0
    ) {
        return;
    }

    forEach(baseElements, baseElement => {
        new photoZoom(baseElement);
    });
}

init();

/* == INITIALIZATION ======================================================== */